import React, { FunctionComponent } from 'react'
import { Route, Switch, RouteComponentProps } from 'react-router-dom'

import { Err404 } from '../../../components'
import {
  ApplicationsDetailReport,
  ClicksDetailReport,
  PerformanceReport,
  SalesDetailReport,
} from '../../../pages/old'

interface ReportsRouterProps extends RouteComponentProps<{ page: string }> {}

const ReportsRouter: FunctionComponent<ReportsRouterProps> = ({ match }) => (
  <Switch>
    <Route
      path={`${match.path}/details/clicks`}
      component={ClicksDetailReport}
    />
    <Route path={`${match.path}/details/sales`} component={SalesDetailReport} />
    <Route
      path={`${match.path}/details/applications`}
      component={ApplicationsDetailReport}
    />
    <Route path={match.path} component={PerformanceReport} />
    <Route component={Err404} />
  </Switch>
)

export default ReportsRouter
